import { zodResolver } from '@hookform/resolvers/zod';
import { Modal } from '@mantine/core';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';

import { Form, TextInputControl } from '@/core/components';

interface ValidationRejectModalProps {
  onSubmit: (v: { note: string }) => void;
  isSubmitting: boolean;
  onClose: () => void;
}

const schema = z.object({
  note: z.string().trim().min(3),
});

type NoteSchema = z.infer<typeof schema>;

export function ValidationRejectModal(props: ValidationRejectModalProps) {
  const { onClose, isSubmitting, onSubmit } = props;
  const { t } = useTranslation();
  const { control, handleSubmit } = useForm<NoteSchema>({
    defaultValues: { note: '' },
    resolver: zodResolver(schema),
  });

  return (
    <Modal
      opened
      onClose={onClose}
      title={t('validation.reject')}
      closeButtonProps={{ 'aria-label': t('button.close') }}
    >
      <Form
        onSubmit={handleSubmit(onSubmit)}
        onCancel={onClose}
        title=""
        isSubmitting={isSubmitting}
      >
        <TextInputControl
          label={t('validation.fields.note')}
          name="note"
          description={t('validation.fields.noteDescription')}
          control={control}
          isSubmitting={isSubmitting}
        />
      </Form>
    </Modal>
  );
}
